<template>
  <div class="preview" v-loading="loading">
    <img class="preview__iphone-overlay" src="../../assets/iphone-new-cleaned-up.png" />
    <iframe ref="iframeRef" v-if="showIframe" class="preview__iframe" :src="url" @load="frameLoaded()" ></iframe>
  </div>
</template>

<script>
export default {
  name: 'ba-build-preview',
  props: ['url'],
  data () {
    return {
      loading: true,
      showIframe: true,
      loadingIframe: true
    }
  },
  ready () {

  },
  methods: {
    frameLoaded () {
      this.loading = false
    },
    invalidateIframe () {
      this.loading = true
      let url = this.$refs.iframeRef.src
      this.$refs.iframeRef.src = ''
      this.$refs.iframeRef.src = url
    }
  }
}
</script>
<style scoped>
  .preview * {
    box-sizing: border-box;
  }
  .preview {
    position: relative;

    width: 403px;
    margin-left: auto;
    margin-right: auto;
  }
  .preview__iframe{
    display: block;
    position: absolute;
    top: 56px;
    left: 24px;
    background-color: #e4e4e4;
    width: 356px;
    height: 740px;
    border: 1px solid #eee;
  }
  .preview__iphone-overlay {
    position: relative;
    z-index: 1;
    pointer-events: none;
  }
  /* do not need frame on mobile devices */
  @media (max-width: 575px) {
    .preview__iframe{
      margin-left: 1%;
      margin-right: 1%;
      width: 98%;
      position:static;
      margin-bottom: 50px;
    }

    .preview__iphone-overlay {
      display: none;
    }
    .preview {
      width: auto;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>
